<template>
  <div class="news">
    <h3 class="mt-4">{{ item.title }}</h3>
    <time>{{
      moment(item.datetime.toDate()).format("DD-MM-YYYY hh:mm:ss A")
    }}</time>
    <p class="inline-desc">
      {{ item.description }}
    </p>
    <v-btn small block color="primary" @click="lc_scrollTop" :to="{name:'News Detail',params:{id:item.id,news:item}}">Read more</v-btn>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props:["item"],
  methods:{
    moment,
    lc_scrollTop() {
      window.scrollTo(0, 0);
    },
  }
};
</script>

<style>
</style>